// Layout-only route for the /system-admin/orgs segment. The actual list page
// lives in `orgs.index.tsx` so child detail routes (orgs.$orgId*) can render
// inside this Outlet — without it, navigating to /system-admin/orgs/<id>
// silently keeps the list visible because the child has no rendering slot.
// Mirrors the working `_admin/knowledges.tsx` pattern.
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/system-admin/orgs")({
  component: SystemAdminOrgsLayout,
});

function SystemAdminOrgsLayout() {
  return <Outlet />;
}
